// pt-BR of the assistant panel; complete for every key of en-assistant.ts (checked by the type).
import type { enAssistant } from "./en-assistant.ts";

export const ptBRAssistant: Record<keyof typeof enAssistant, string> = {
  "assistant.work.task": "Tarefa",
  "assistant.work.planner": "Agente de planejamento",
  "assistant.work.prd": "Versão do PRD",
  "assistant.work.requested": "Na fila",
  "assistant.work.running": "Em execução",
  "assistant.work.completed": "Planejamento concluído",
  "assistant.work.failed": "Falhou",
  "assistant.work.unavailable": "Status indisponível",
  "assistant.work.observed": "Status do registro consultado",
  "assistant.timing.started": "Início:",
  "assistant.artifact.partial": "Incompleto — continuação necessária",
  "assistant.artifact.modelReview": "Revisado pelo modelo que gerou; revisão independente não confirmada",
  "assistant.artifact.structuralReview": "Bytes do arquivo conferidos; revisão do conteúdo pendente",
  "assistant.artifact.failed": "Não foi possível abrir o arquivo. Você pode tentar novamente ou baixá-lo.",
  "assistant.artifact.view": "Ler na conversa",
  "assistant.artifacts": "Arquivos da conversa",
  "assistant.actionTitle.create_project_request": "Registrar PRD e planejar {title} em segundo plano",
  "assistant.detail.project_request_queued": "PRD salvo e planejamento na fila; a execução segue as políticas do projeto. Você pode continuar a conversa.",
  "assistant.actionTitle.review_learnings": "Revisar aprendizados",
  "assistant.actionTitle.server_operation": "Solicitar operação no servidor {server}",
  "assistant.actionTitle.github_operation": "GitHub: {operation}",
  "assistant.action.githubRequest": "Revisar a solicitação exata ao GitHub",
  "assistant.detail.github_request_completed": "confirmado pela API cadastrada do GitHub",
  "assistant.detail.github_request_refused": "o GitHub recusou a solicitação; confira permissões e validação",
  "assistant.detail.github_outcome_requires_reconciliation": "resultado desconhecido; confira a operação registrada antes de tentar novamente",
  "assistant.action.requested": "Solicitado: {label}",
  "assistant.detail.learning_review_queued": "revisão solicitada; o governador de aprendizados ainda não concluiu",
  "assistant.detail.server_operation_queued": "na fila do worker; a execução ainda não foi confirmada",
  "assistant.action.learningReviewActor": "Revisão por IA pelo serviço learning-governor; solicitar uma revisão não aprova um aprendizado.",
  "assistant.action.serverTarget": "Servidor: {server}",
  "assistant.action.serverProject": "Projeto: {project}",
  "assistant.action.serverDisruption": "Interrupção declarada: {disruption}; a API pode elevar esse nível.",
  "assistant.action.serverQueuedHint": "Esta ação solicita uma operação na fila. O worker verifica a autorização do host antes de executar.",
  "assistant.disruption.none": "Nenhuma",
  "assistant.disruption.application": "Aplicação",
  "assistant.disruption.host": "Servidor",
  "assistant.title": "Assistente",
  "assistant.timing.elapsed": "Tempo decorrido: {duration}",
  "assistant.timing.duration": "Duração do turno: {duration}",
  "assistant.close": "Fechar assistente",
  "assistant.dock": "Fixar painel",
  "assistant.scope.home": "Todos os seus projetos",
  "assistant.scope.project": "Este projeto",
  "assistant.log": "Conversa com o assistente",
  "assistant.empty": "Converse, pergunte sobre seus projetos ou peça um arquivo.",
  "assistant.historyFailed": "Não foi possível carregar a conversa.",
  "assistant.composer.label": "Pergunte ao assistente",
  "assistant.composer.placeholder": "Envie uma mensagem…",
  "assistant.composer.hint": "Enter envia; Shift+Enter quebra a linha.",
  "assistant.send": "Enviar",
  "assistant.stop": "Parar",
  "assistant.stopping": "Parando…",
  "assistant.counter": "{n} / {max}",
  "assistant.tooLong": "Texto longo demais: encurte a pergunta para {max} caracteres.",
  "assistant.thinking": "Trabalhando nisso…",
  "assistant.progress.model": "Gerando uma resposta…",
  "assistant.progress.tools": "Executando ferramentas…",
  "assistant.progress.answer": "Escrevendo a resposta…",
  "assistant.stillWorking": "Ainda trabalhando nisso — tente de novo em instantes.",
  "assistant.checkAgain": "Verificar de novo",
  "assistant.turnActive": "Já há uma pergunta sendo respondida nesta conversa. Aguarde a resposta ou clique em Parar.",
  "assistant.sendFailed": "A pergunta não foi enviada",
  "assistant.suggestions": "Respostas sugeridas",
  "assistant.nothingToReport": "Nada precisa da sua atenção agora.",
  "assistant.summaryChip": "Resumo do projeto",
  "assistant.prompt.summary": "O que está esperando por mim neste projeto?",
  "assistant.prompt.readiness": "Este projeto está pronto para iniciar?",

  "assistant.action.notNow": "Agora não",
  "assistant.action.dismissed": "Ignorado: {label}",
  "assistant.action.running": "Executando: {label}…",
  "assistant.action.pending": "Iniciado: {label}",
  "assistant.action.succeeded": "Feito: {label}",
  "assistant.action.failed": "Falhou: {label}",
  "assistant.action.unknown": "Não confirmado: {label}. Não foi possível confirmar se esta ação terminou. Ela não será repetida sozinha; confira a tarefa ou o projeto antes de tentar de novo.",
  "assistant.action.elsewhere": "Já tratado: {label}",
  "assistant.detail.ready": "pronto",
  "assistant.detail.not_ready": "não pronto",
  "assistant.detail.still_running": "ainda em andamento",
  "assistant.detail.check_failed": "a verificação não pôde rodar",
  "assistant.detail.version_conflict": "isso mudou nesse meio-tempo",
  "assistant.detail.forbidden": "você não tem permissão para isso",
  "assistant.detail.not_found": "isso não existe mais",
  "assistant.detail.gate_pending": "ainda há um impedimento em aberto",
  "assistant.detail.policy_denied": "uma política recusou",
  "assistant.detail.validation_failed": "o pedido foi recusado por ser inválido",
  "assistant.detail.rate_limited": "muitas requisições; tente de novo em instantes",
  "assistant.detail.unavailable": "o serviço está indisponível",
  "assistant.detail.network": "a conexão falhou",
  "assistant.detail.project_created": "abrindo o quadro dele",
  "assistant.detail.github_unavailable": "nenhuma conexão ativa com o GitHub; conecte o GitHub em Integrações antes",
  "assistant.detail.repository_exists": "já existe um repositório com esse nome",

  "assistant.actionTitle.validate_project": "Validar o projeto",
  "assistant.actionTitle.open_page": "Abrir {page}",
  "assistant.actionTitle.open_page_of": "Abrir {page} — {project}",
  "assistant.actionTitle.open_page_other": "Abrir {page} de outro projeto",
  "assistant.actionTitle.retry_task": "Tentar de novo a tarefa {task}",
  "assistant.actionTitle.unblock_task": "Desbloquear a tarefa {task}",
  "assistant.actionTitle.resource_available": "Marcar o recurso como disponível para a tarefa {task}",
  "assistant.actionTitle.start_project": "Iniciar o projeto",
  "assistant.actionTitle.resume_project": "Retomar o projeto",
  "assistant.actionTitle.create_task": "Criar a tarefa “{title}”",
  "assistant.actionTitle.add_guidance": "Adicionar orientação à tarefa {task}",
  "assistant.actionTitle.open_settings_form": "Corrigir {field} nas configurações do projeto",
  "assistant.actionTitle.decide_approval": "Responder ao pedido — opção {option}",
  "assistant.actionTitle.connect_repository": "Conectar repositório",
  "assistant.actionTitle.create_project_from_brief": "Criar o projeto “{name}”",
  "assistant.field.repository_url": "a URL do repositório",
  "assistant.field.base_branch": "a branch base",
  "assistant.action.guidance": "Orientação: {text}",
  "assistant.action.reviewBrief": "Revisar o resumo ({count} caracteres)",
  // D34 (assistente operador)
  "assistant.actionTitle.create_task_start": "Criar e iniciar a tarefa “{title}”",
  "assistant.actionTitle.update_project_settings": "Atualizar as configurações do projeto: {fields}",
  "assistant.actionTitle.set_execution_policy_on": "Ligar a execução de comandos em sandbox",
  "assistant.actionTitle.set_execution_policy_off": "Desligar a execução de comandos",
  "assistant.actionTitle.edit_task": "Editar a tarefa {task}",
  "assistant.actionTitle.move_task": "Tarefa {task}: {move}",
  "assistant.actionTitle.cancel_task": "Cancelar a tarefa {task}",
  "assistant.actionTitle.start_task_run": "Pôr os agentes na tarefa {task}",
  "assistant.actionTitle.pause_project": "Pausar o projeto",
  "assistant.actionTitle.drain_project": "Esvaziar o projeto (terminar as tarefas em andamento, sem iniciar novas)",
  "assistant.actionTitle.run_model_probe": "Testar as capacidades do modelo (até {cents})",
  "assistant.actionTitle.update_agent_profile": "Alterar um perfil de agente",
  "assistant.actionTitle.update_model_target_disabled": "Desativar um modelo",
  "assistant.actionTitle.update_model_target_unverified": "Mandar um modelo de volta para verificação",
  "assistant.actionTitle.update_provider_connection_disabled": "Desativar uma conexão de provedor",
  "assistant.actionTitle.update_provider_connection_draft": "Voltar uma conexão de provedor para rascunho",
  "assistant.actionTitle.activate_integration": "Ativar uma integração",
  "assistant.actionTitle.activate_routing_config": "Ativar uma configuração de roteamento",
  "assistant.actionTitle.publish_project": "Publicar o app",
  "assistant.field.name": "nome",
  "assistant.field.description": "descrição",
  "assistant.field.test_command": "comando de teste",
  "assistant.field.build_command": "comando de build",
  "assistant.field.workspace_subpath": "subpasta do workspace",
  "assistant.move.mark_ready": "mover para A fazer",
  "assistant.move.pause": "pausar",
  "assistant.move.resume": "retomar",
  "assistant.move.reopen": "reabrir",
  "assistant.move.block": "bloquear",
  "assistant.action.refused": "Não permitido para o seu papel: {label}",
  "assistant.followUp.prompt": "Continue com os resultados destas ações.",
  "assistant.followUp.note": "Continuação automática {n} de {max}",
  "assistant.detail.no_workspace": "o projeto ainda não tem workspace",
  "assistant.detail.policy_on": "ligada enquanto o sandbox do worker estiver verificado",
  "assistant.detail.policy_off": "os comandos passam a ser recusados",
  "assistant.detail.task_started": "execução aceita; acompanhe o status registrado da tarefa para saber o progresso real",
  "assistant.detail.task_queued": "criada e priorizada; começa quando o projeto puder executá-la",
  "assistant.detail.already_running": "já estava em execução",
  "assistant.detail.publish_started": "publicação solicitada; aguardando confirmação do deploy",
  "assistant.detail.project_not_active": "o projeto não está em execução",
  "assistant.detail.at_capacity": "todas as vagas de tarefa estão ocupadas",
  "assistant.detail.task_not_startable": "a tarefa não está numa coluna que pode iniciar",
  "assistant.detail.invalid_transition": "essa mudança não é permitida no estado atual",
  "assistant.detail.execution_policy_not_settable": "a política de execução é definida por um administrador",
  "assistant.detail.planning_started": "planejamento iniciado",
  "assistant.detail.guardian_queued": "o guardião vai rodar em instantes",
  "assistant.detail.guardian_action_requested": "solicitado; o worker executa",
  "assistant.detail.no_system_project": "nenhum projeto MaestrOS foi encontrado",
  "assistant.actionTitle.start_planning_run": "Iniciar o planejamento a partir do PRD",
  // D37.3 (idioma do conteúdo)
  "assistant.actionTitle.translate_tasks": "Traduzir para o idioma do conteúdo as tarefas ainda não iniciadas",
  "assistant.detail.translation_queued": "tradução na fila; um modelo pago pede confirmação no Kanban",
  "assistant.detail.nothing_to_translate": "não há mais tarefas para traduzir",
  "assistant.actionTitle.create_system_task": "Criar a tarefa do MaestrOS “{title}”",
  "assistant.actionTitle.create_system_task_start": "Criar e iniciar a tarefa do MaestrOS “{title}”",
  "assistant.actionTitle.run_guardian": "Rodar o Guardião do servidor agora",
  "assistant.actionTitle.guardian_incident_action_restart": "Reiniciar a aplicação do incidente",
  "assistant.actionTitle.guardian_incident_action_redeploy": "Reimplantar a aplicação do incidente",
  "assistant.actionReason.readiness.never_checked": "Este projeto nunca foi verificado.",
  "assistant.actionReason.readiness.stale": "O último resultado de prontidão está desatualizado; verifique de novo antes de confiar nele.",
  "assistant.actionReason.readiness.setting": "Esta configuração do projeto precisa de atenção.",
  "assistant.actionReason.readiness.no_route": "Nenhuma rota de modelo está habilitada para este projeto ainda.",
  "assistant.actionReason.readiness.connect_repository": "Conecte o repositório do GitHub do projeto para cloná-lo e detectar o comando de teste.",
  "assistant.actionReason.summary.waiting_for_you": "Há itens aguardando você.",
  "assistant.actionReason.task.infra_failure": "Esta tarefa falhou por um erro de infraestrutura e ainda não foi tentada de novo.",
  "assistant.actionReason.task.blocked": "Esta tarefa está bloqueada.",
  "assistant.actionReason.home.needs_attention": "Este projeto precisa de atenção.",

  "assistant.mode.rules": "Modo regras: resposta montada com os dados do MaestrOS, sem IA.",
  "assistant.mode.not_configured": "Modo regras: a IA ainda não está configurada.",
  "assistant.mode.budget_exhausted": "Modo regras: o orçamento de IA do assistente para hoje acabou.",
  "assistant.diagnostics.summary": "Diagnóstico",
  "assistant.diagnostics.profile": "Perfil: {id}",
  "assistant.diagnostics.version": "Versão: {id}",
  "assistant.diagnostics.noVersion": "sem versão",
  "assistant.diagnostics.capabilities": "Capacidades ({count}): {list}",
  "assistant.budgetHigh": "80% do orçamento de hoje do assistente já foi usado.",

  "assistant.line.summary.waiting_for_you": "Itens aguardando você: {count}.",
  "assistant.line.summary.blocked": "Tarefas bloqueadas: {count}.",
  "assistant.line.summary.waiting_resource": "Tarefas aguardando um recurso: {count}.",
  "assistant.line.summary.failed": "Tarefas com falha: {count}.",
  "assistant.line.summary.progress": "{done} de {total} tarefas concluídas.",
  "assistant.line.home.waiting_for_you": "Itens aguardando você nos seus projetos: {count}.",
  "assistant.line.home.blocked": "Tarefas bloqueadas nos seus projetos: {count}.",
  "assistant.line.readiness.failed.repository": "A verificação do repositório falhou: o MaestrOS não conseguiu acessar o repositório do projeto.",
  "assistant.line.readiness.failed.base_branch": "A verificação da branch base falhou: a branch base configurada não foi encontrada no repositório.",
  "assistant.line.readiness.failed.workspace_authorized": "O workspace ainda não está autorizado para este projeto.",
  "assistant.line.readiness.failed.runner_healthy": "Nenhum runner saudável está disponível para executar tarefas.",
  "assistant.line.readiness.failed.executor_available": "Nenhum executor está disponível para rodar as tarefas.",
  "assistant.line.readiness.failed.test_command": "A verificação do comando de testes falhou: defina um comando de testes que o runner consiga executar.",
  "assistant.line.readiness.failed.eligible_route": "Nenhuma rota de modelo está habilitada para este projeto ainda.",
  "assistant.line.readiness.unknown.repository": "Não foi possível concluir a verificação do repositório; valide o projeto de novo.",
  "assistant.line.readiness.unknown.base_branch": "Não foi possível concluir a verificação da branch base; valide o projeto de novo.",
  "assistant.line.readiness.unknown.workspace_authorized": "Não foi possível concluir a verificação de autorização do workspace; valide o projeto de novo.",
  "assistant.line.readiness.unknown.runner_healthy": "Não foi possível concluir a verificação de runner saudável; valide o projeto de novo.",
  "assistant.line.readiness.unknown.executor_available": "Não foi possível concluir a verificação do executor; valide o projeto de novo.",
  "assistant.line.readiness.unknown.test_command": "Não foi possível concluir a verificação do comando de testes; valide o projeto de novo.",
  "assistant.line.readiness.unknown.eligible_route": "Não foi possível concluir a verificação da rota de modelo; valide o projeto de novo.",
  "assistant.line.readiness.config_impediments": "A configuração efetiva do projeto (agentes, rotas, Maestro) tem {count} impedimento(s): veja Configurações › Roteamento e Maestro.",
  "assistant.line.readiness.engine_unavailable": "O motor de execução não está respondendo, então nenhuma tarefa pode rodar agora.",
  "assistant.line.assistant.engine_unavailable": "O motor de IA está indisponível agora, então esta resposta vem das regras.",
  "assistant.line.access.lost": "Você não tem mais acesso a este projeto, então o assistente não pode responder aqui.",
  "assistant.line.turn.stopped": "Você parou esta resposta.",
  "assistant.line.turn.ceiling_reached": "A resposta parou no limite por pergunta.",
  "assistant.line.ai.runtime_disabled": "O runtime de IA está desligado neste servidor, então esta resposta vem das regras.",
  "assistant.line.ai.no_route": "Ainda não há rota de modelo de IA configurada para o assistente, então esta resposta vem das regras.",
  "assistant.line.ai.not_allowed": "Chamadas reais de IA ainda não são permitidas neste servidor, então esta resposta vem das regras.",
  "assistant.line.ai.no_pricing": "O modelo do assistente não tem preço definido, então não é usado e esta resposta vem das regras.",
  "assistant.line.ai.try_again": "A IA não conseguiu responder desta vez. Tente de novo em instantes.",
  "assistant.line.budget.daily_ceiling": "O orçamento do assistente para hoje acabou, então esta resposta vem das regras.",
  "assistant.line.budget.unknown_cost": "Uma chamada do assistente hoje tem custo desconhecido, então as respostas com IA ficam pausadas até amanhã.",
  "assistant.line.budget.call_refused": "Um limite de gasto (como o limite rígido do projeto) bloqueou a chamada de IA, então esta resposta vem das regras.",

  "assistant.usage.title": "Uso do assistente",
  "assistant.usage.hint": "Gasto, perguntas e ações do assistente pago, para toda a organização.",
  "assistant.usage.unknown": "desconhecido",
  "assistant.usage.today": "Hoje",
  "assistant.usage.avgPerQuestion": "Média por pergunta",
  "assistant.usage.maxPerQuestion": "Máximo por pergunta",
  "assistant.usage.stoppedAtCeiling": "Paradas no limite por pergunta",
  "assistant.usage.unknownCostCalls": "{n} chamada(s) com custo desconhecido",
  "assistant.usage.byDay": "Gasto por dia",
  "assistant.usage.noDays": "Nenhuma pergunta ao assistente nesta janela.",
  "assistant.usage.modes": "Respostas por modo",
  "assistant.usage.mode.ai": "IA",
  "assistant.usage.mode.rules": "Regras",
  "assistant.usage.mode.not_configured": "Não configurado",
  "assistant.usage.mode.budget_exhausted": "Orçamento esgotado",
  "assistant.usage.mode.error": "Erro",
  "assistant.usage.byProject": "Gasto por projeto",
  "assistant.usage.noProjects": "Nenhuma pergunta em projeto nesta janela.",
  "assistant.usage.byUser": "Gasto por pessoa",
  "assistant.usage.noUsers": "Nenhuma pergunta nesta janela.",
  "assistant.usage.actions": "Ações",
  "assistant.usage.actions.proposed": "Propostas",
  "assistant.usage.actions.autoExecuted": "Executadas automaticamente",
  "assistant.usage.actions.clicked": "Clicadas",
  "assistant.usage.actions.failed": "Falharam",
  "assistant.usage.col.day": "Dia",
  "assistant.usage.col.spent": "Gasto",
  "assistant.usage.col.limit": "Limite",
  "assistant.usage.col.questions": "Perguntas",
  "assistant.usage.col.project": "Projeto",
  "assistant.usage.col.user": "Pessoa",
  "assistant.usage.questionsShort": "{n} pergunta(s)",
  "assistant.usage.homeLabel": "Início",
  "assistant.usage.partial": "parcial",
  "assistant.usage.noteHomePartial": "Os totais de gasto (hoje, por dia e por projeto) incluem as perguntas de todo mundo, inclusive as feitas no Início. O gasto por pessoa, a contagem de perguntas e os valores por pergunta só incluem as perguntas do Início das conversas que você pode ler (as suas).",
  "assistant.usage.hintProjectCeiling": "Este limite é compartilhado por toda a organização, não só por este projeto.",
  "assistant.actionTitle.delete_project": "Excluir o projeto {project}",
  "assistant.detail.project_deleted": "projeto excluído",
  "projectDelete.dangerZone": "Zona de perigo",
  "projectDelete.body": "Excluir remove o projeto, suas tarefas, execuções e configurações do MaestrOS. Não dá para desfazer aqui. Pause ou esvazie o projeto antes se houver trabalho em andamento.",
  "projectDelete.repositoryKept": "O repositório do GitHub vinculado não é excluído.",
  "projectDelete.button": "Excluir projeto",
  "projectDelete.typeName": "Digite o nome do projeto ({name}) para confirmar",
  "projectDelete.confirm": "Excluir este projeto",
  "projectDelete.summary": "{name}: {total} tarefas ({done} concluídas, {cancelled} canceladas, {inProgress} em andamento).",
  "projectDelete.runningWork": "Há trabalho em andamento neste projeto: pause ou esvazie antes de excluir.",
  "projectDelete.factsUnavailable": "Não foi possível carregar a contagem de tarefas do projeto.",
};
